export enum ConsultStatus {
  NULL = "NULL",
  PLANNED = "planned",
  IN_PROGRESS = "in-progress",
  FINISHED = "finished",
  CANCELLED = "cancelled",
  ENTERED_IN_ERROR = "entered-in-error",
  // SteadyMD Statuses
  SCHEDULED = "scheduled",
  WAITING_TO_SCHEDULE = "waiting_to_schedule",
  COMPLETED = "completed",
  REJECTED = "rejected",
  REFERRED_OUT = "referred_out",
  CANCELED = "canceled",
}

export enum ConsultDisposition {
  NULL = "NULL",
  DIAGNOSED = "diagnosed",
  REFERRED_OUT = "referred-out",
  AUTO_REFERRED_OUT = "auto-referred-out",
  INSUFFICIENT_PATIENT_ID = "insufficient-patient-id",
  PATIENT_NO_SHOW = "patient-no-show",
  OTHER_CANCELLATION = "other-cancellation",
  PATIENT_CANCELLATION = "patient-cancellation",
}

export enum LandingPageGoto {
  SCHEDULING = "scheduling",
  MEDICAL_INTAKE = "intake",
  LABS = "labs",
  PHARMACY = "pharmacy",
  INSURANCE = "insurance",
}
